import { render, staticRenderFns } from "./PadrillosMadrillasByDeathReasonModal.vue?vue&type=template&id=50a77a73"
import script from "./PadrillosMadrillasByDeathReasonModal.vue?vue&type=script&lang=js"
export * from "./PadrillosMadrillasByDeathReasonModal.vue?vue&type=script&lang=js"
import style0 from "./PadrillosMadrillasByDeathReasonModal.vue?vue&type=style&index=0&id=50a77a73&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports